import { Component, Inject, Input, input } from '@angular/core';
import { PolicyService } from '../../core/services/policy.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-security-privacy-cookie-policy',
  templateUrl: './security-privacy-cookie-policy.component.html',
  styleUrl: './security-privacy-cookie-policy.component.scss'
})
export class SecurityPrivacyCookiePolicyComponent {


  privacyPolicy = '';

  constructor(@Inject(MAT_DIALOG_DATA) public data: {appName: string}, private policyService: PolicyService) {

    if(this.data?.appName != 'AssessmentApp'){
    policyService.getPrivacyPolicy().subscribe(val => {
      this.privacyPolicy = val;
    });
  }
  else{
    policyService.getAssessmentAppPrivacyPolicy().subscribe(val => {
      this.privacyPolicy = val;
    }); 
  }

  }

}
